import styles from './agendaForm.module.scss';
export const AgendaFormItem = ({items=[]}) => {
  if (!items.length) return null;
  return(
    <div className={styles.agendaBody}>
      {items.map((item, index) => (
        <div
          className={styles.agendaRow}
          key={index}
        >
          <div className={styles.time}>{item.time}</div>
          <div className={styles.topic}>{item.topic}</div>
          <div className={styles.speaker}>
            <span className={styles.speakerName}>
              {item.speaker}
              <br />
            </span>
            <span className={styles.speakerPosition}>
              {item.position.split('\n').map((line, i) => (
                <div key={i}>{line}</div>
              ))}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};
